export const handleImageChange = (event, setState) => {
    const file = event.target.files[0]
    if (file) {
        const reader = new FileReader()
        reader.onload = (e) => {
            setState({ upload_url: e.target.result, upload_file: file })
        }
        reader.readAsDataURL(file)
    }
}